module.exports = __webpack_public_path__ + "static/media/4D.f406e136.jpg";